import ErrorIcon from '@mui/icons-material/Error'
import { Box } from '@mui/material'
import { FC } from 'react'

interface Props {
    text: string
}

const RequestMessageError: FC<Props> = ({ text }) => {
    return (
        <Box
            sx={{
                width: '100%',
                my: 1,
                display: 'flex',
                alignItems: 'center',
            }}>
            <ErrorIcon
                color="error"
                sx={{
                    mr: 1,
                }}
            />
            {text}
        </Box>
    )
}

export default RequestMessageError
